import { inject } from '@angular/core';
import { patchState, signalStore, withMethods } from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  withEntities,
} from '@ngrx/signals/entities';
import { ManagementService } from '@thiememeulenhoff/ng-api-gateway';
import { Arrangement } from '@thiememeulenhoff/types';
import { firstValueFrom } from 'rxjs';
import {
  toRequestError,
  withRequestStatus,
} from '../_utils/request-status.feature';

const arrangementsConfig = entityConfig({
  entity: {} as Arrangement,
  collection: 'arrangements',
  selectId: (arrangement: Arrangement) => arrangement.code,
});

export const ManagementArrangementsStore = signalStore(
  { providedIn: 'root' },
  withEntities(arrangementsConfig),
  withRequestStatus(),
  withMethods((store, managementService = inject(ManagementService)) => ({
    async fetchArrangements(): Promise<void> {
      patchState(store, { requestStatus: 'loading' });

      try {
        const arrangements = await firstValueFrom(
          managementService.fetchManagementArrangements(),
        );

        patchState(store, setAllEntities(arrangements, arrangementsConfig), {
          requestStatus: 'success',
        });
      } catch (error) {
        patchState(store, { requestStatus: toRequestError(error) });
      }
    },
  })),
);
